import React, { useState, useEffect } from "react";
import { Table, Form } from "react-bootstrap";
import ExportToExcel from "../../../../components/ExportToExcel";
import Pagination from "../../../../components/Pagination";
import SearchBar from "../../../../components/SearchBar";
import { useNavigate } from "react-router-dom";
import OverlayTrigger from "react-bootstrap/OverlayTrigger";
import Tooltip from "react-bootstrap/Tooltip";

const PR_Table = ({
  data,
  columns,
  defaultColumns,
  itemsPerPage,
  searchTerm,
  setSearchTerm,
  handleIcon1,
  handleIcon2,
  handleIcon3,
  handleIcon4,
  handleIcon5,
  showIcon1,
  showIcon2,
  showIcon3,
  showIcon4,
  showIcon5,
  icons,
  handleAddNew
}) => {
  const [visibleColumns, setVisibleColumns] = useState(defaultColumns);
  const [currentPage, setCurrentPage] = useState(1);

  useEffect(() => {
    setCurrentPage(1);
  }, [searchTerm]);

  const toggleColumn = (columnName) => {
    setVisibleColumns({
      ...visibleColumns,
      [columnName]: !visibleColumns[columnName],
    });
  };

  const handlePageChange = (pageNumber) => {
    setCurrentPage(pageNumber);
  };
  const navigate = useNavigate();

  const handleSchedule = (url, candidate_id, job_description_id) => {
    navigate(`${url}${candidate_id}/${job_description_id}`);
  };
  const filteredData = data.filter((item) =>
    Object.values(item).some((value) =>
      String(value).toLowerCase().includes(searchTerm.toLowerCase())
    )
  );
  // handleMouseOver
  const handleMouseOver = () => {
  };

  const totalPages = Math.ceil(filteredData.length / itemsPerPage);
  const startIndex = (currentPage - 1) * itemsPerPage;
  const endIndex = Math.min(startIndex + itemsPerPage, filteredData.length);
  const currentData = filteredData.slice(startIndex, endIndex);


  return (
    <div>
      <div className="d-flex justify-content-between">
        <div className="col-lg-2 mb-3 mb-md-0 me-1">
          <SearchBar searchTerm={searchTerm} setSearchTerm={setSearchTerm} />
        </div>

        <div className="d-flex justify-content-end">
          <div className="me-1">
            <ExportToExcel data={filteredData} filename="tableData.xlsx" />
          </div>
          <div className="btn-group me-2">
            <button
              type="button"
              className="dropdown-toggle skill-button"
              data-bs-toggle="dropdown"
              aria-expanded="false"
              id="excel-btn"
            >
              <i className="bi bi-list"></i>
            </button>

            <ul className="dropdown-menu p-2">
              <div className="row">
                <Form.Group>
                  {Object.keys(visibleColumns).map((columnName) => (
                    <Form.Check
                      key={columnName}
                      type="checkbox"
                      id={`checkbox-${columnName}`}
                      label={columnName} //custom column name
                      checked={visibleColumns[columnName]}
                      onChange={() => toggleColumn(columnName)}
                    />
                  ))}
                </Form.Group>
              </div>
            </ul>
          </div>
          <OverlayTrigger
            placement="bottom"
            overlay={<Tooltip id="tooltip-top">Add New</Tooltip>}
          >
            <button id="Add-btn" onClick={handleAddNew}>
              <i className="fa fa-plus"></i>Add
            </button>
          </OverlayTrigger>
        </div>
      </div>
      <div className="box-body table-responsive">
        <Table striped borderless hover>
          <thead id="thcolor" className="text-center ">
            <tr>
              {Object.keys(columns).map(
                (columnName) =>
                  visibleColumns[columnName] && (
                    <th key={columnName}>{columns[columnName].text}</th>
                  )
              )}
              <th>Action</th>
            </tr>
          </thead>
          <tbody className="border-bottom">
            {currentData.map((item, index) => (
              <tr key={index}>
                {Object.keys(columns).map((columnName) => {
                  const isDateColumn =
                    columns[columnName].text.toLowerCase().includes("doj") ||
                    columns[columnName].text.toLowerCase().includes("joining");
                  const columnAlignment = columns[columnName].align || "left";
                  return (
                    visibleColumns[columnName] && (
                      <td
                        className={`text-${columnAlignment}`}
                        key={columnName}
                      >
                        {item[columnName]}
                      </td>
                    )
                  );
                })}
                <td>
                  <div className="d-flex justify-content-center text-center">
                    {showIcon1 && (
                      <OverlayTrigger
                        placement="bottom"
                        overlay={<Tooltip id="tooltip-bottom">Edit</Tooltip>}
                      >
                        <div
                          className="me-2"
                          onMouseOver={handleMouseOver}
                          onClick={() => handleIcon1(item)}
                        >
                          {icons.Icon1}
                        </div>
                      </OverlayTrigger>
                    )}
                    {showIcon2 && (
                      <div
                        className="me-2 disable"
                        onClick={() => handleIcon2(item)}
                      >
                        {icons.Icon2}
                      </div>
                    )}
                    {showIcon3 && (
                      <OverlayTrigger
                        placement="bottom"
                        overlay={<Tooltip id="tooltip-bottom">View</Tooltip>}
                      >
                        <div
                          className="me-2"
                          style={{ color: "#06576C" }}
                          onClick={() => handleIcon3(item)}
                        >
                          {icons.Icon3}
                        </div>
                      </OverlayTrigger>
                    )}
                    {showIcon4 && (
                      <OverlayTrigger
                        placement="bottom"
                        overlay={
                          <Tooltip id="tooltip-bottom">HR Authority</Tooltip>
                        }
                      >
                        <div
                          className="me-2"
                          onClick={() =>
                            handleSchedule(
                              "/hr-authority/",
                              item.ID,
                              item.JobDescriptionID
                            )
                          }
                        >
                          {icons.Icon4}
                        </div>
                      </OverlayTrigger>
                    )}
                    {showIcon5 && (
                      <div className="me-2" onClick={() => handleIcon5(item)}>
                        {icons.Icon5}
                      </div>
                    )}
                  </div>
                </td>
              </tr>
            ))}
          </tbody>
        </Table>

        <div className="d-flex justify-content-end">
          <Pagination
            itemsPerPage={itemsPerPage}
            totalItems={filteredData.length}
            currentPage={currentPage}
            onPageChange={handlePageChange}
          />
        </div>
      </div>
    </div>
  );
};

export default PR_Table;
